import SearchScreen from './components/SearchScreen'

export default {
  path: '/buscar',
  name: 'Search',
  component: SearchScreen,
  children: [
    {
      path: ':slug',
      name: 'SearchCategory'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/screens/Search/index.js